import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ɵCodegenComponentFactoryResolver } from '@angular/core';
import { NzFormatEmitEvent, NzTreeComponent } from 'ng-zorro-antd';
import { getICD10, getICD10List } from './icd10';
import * as _ from 'lodash';

@Component({
  selector: 'app-icd10',
  templateUrl: './icd10.component.html',
  styleUrls: ['./icd10.component.scss']
})

export class Icd10Component implements OnInit {

  @ViewChild('nzTreeComponent', { static: false }) nzTreeComponent!: NzTreeComponent;
  @Input('isVisible') isVisible: boolean;
  @Output() returnICD10 = new EventEmitter();

  selectedValue = null;
  listOfOption: Array<{ value: string; text: string }> = [];
  nzFilterOption = () => true;
  nodes: any;
  list: any;

  constructor() {
    this.nodes = getICD10();
    this.list = getICD10List();
  }

  ngOnInit() {

  }

  search(value: string): void {
    const listOfOption: Array<{ value: string; text: string }> = [];
    if (value.trim().length > 2) {
      _.forEach(this.list, function (data) {
        if (data.title.toLowerCase().search(value.toLocaleLowerCase()) != -1) {
          listOfOption.push({
            value: data.title,
            text: data.title
          });
        }
      })
      this.listOfOption = listOfOption;
    }
  }

  nzEvent(event: NzFormatEmitEvent): void {
    if (event.eventName == 'click') {
      if (event.node.key.slice(0, 3) != '0X0') {
        event.node.isSelected = false
        event.node.isExpanded = false
        const value = event.node.title.slice(event.node.key.length + 1, event.node.title.length)
        const rs = {
          key: event.node.key,
          value: value
        }
        this.returnICD10.emit(rs);
      }
    }
  }

  sendData(event: string): void {
    const code = event.split(' ', 1)
    const key = code[0]
    const value = event.slice(key.length + 1, event.length)
    const rs = {
      key: key,
      value: value
    }
    this.selectedValue = ''
    this.returnICD10.emit(rs);
  }

  handleCancel(): void {
    this.nzTreeComponent.nzShowExpand = false
    this.returnICD10.emit(null);
  }

}
